import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./core/components/PrivateRoute";

import { Text } from "recharts";
import Login from "./auth/pages/Login";
import SelectionProvider from "./core/contexts/SelectionProvider";
// Admin
const Admin = lazy(() => import("./admin/pages/Admin"));
const Dashboard = lazy(() => import("./admin/pages/Dashboard"));
const Faq = lazy(() => import("./admin/pages/Faq"));
const HelpCenter = lazy(() => import("./admin/pages/HelpCenter"));
const Home = lazy(() => import("./admin/pages/Home"));
const Redirect = lazy(() => import("./admin/pages/Redirect"));
const Profile = lazy(() => import("./admin/pages/Profile"));
const ProfileActivity = lazy(() => import("./admin/pages/ProfileActivity"));
const ProfileInformation = lazy(
  () => import("./admin/pages/ProfileInformation")
);
const ProfilePassword = lazy(() => import("./admin/pages/ProfilePassword"));

//Board
const Board = lazy(() => import("./admin/pages/Board"));

//Res
const Res = lazy(() => import("./admin/pages/Res"));

//Vacancy
const Vacancy = lazy(() => import("./admin/pages/Vacancy"));
const VacancyPage = lazy(() => import("./admin/pages/VacancyPage"));

//Emails
const Emails = lazy(() => import("./admin/pages/Emails"));
const EmailsPage = lazy(() => import("./admin/pages/EmailsPage"));

//Announce
const Announce: any = lazy(() => import("./admin/pages/AnnouncePage"));
const AnnounceTable = lazy(() => import("./admin/pages/Announce"));

//Announce
const Clients = lazy(() => import("./admin/pages/ClientPage"));
const ClientsTable = lazy(() => import("./admin/pages/Client"));
const CRM = lazy(() => import("./admin/pages/CRM"));
const Reports = lazy(() => import("./admin/pages/Reports"));

//Candidate
//const Candidate = lazy(() => import("./admin/pages/Candidate"));
const CandidatePage = lazy(() => import("./admin/pages/CandidatePage"));
const CandidateTable = lazy(() => import("./admin/pages/Candidate"));
const Itineraries = lazy(() => import("./admin/pages/Itineraries"));

//Settings
const Settings = lazy(() => import("./admin/pages/Settings"));

//Notifications
const Notifications = lazy(() => import("./admin/pages/Notifications"));

// Auth
const ForgotPassword = lazy(() => import("./auth/pages/ForgotPassword"));
const ForgotPasswordSubmit = lazy(
  () => import("./auth/pages/ForgotPasswordSubmit")
);
//const Login = lazy(() => import("./auth/pages/Login"));
const Register = lazy(() => import("./auth/pages/Register"));

// Calendar
const CalendarApp = lazy(() => import("./calendar/pages/CalendarApp"));

// Chat
const Chat = lazy(() => import("./admin/pages/Chat"));

// Core
const Forbidden = lazy(() => import("./core/pages/Forbidden"));
const NotFound = lazy(() => import("./core/pages/NotFound"));
const UnderConstructions = lazy(
  () => import("./core/pages/UnderConstructions")
);

// Landing
const Landing = lazy(() => import("./landing/pages/Landing"));

// Users
const UserManagement = lazy(() => import("./users/pages/UserManagement"));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="login" element={<Login />} />

      {/* Admin Routes */}
      <Route
        path="admin"
        element={
          <PrivateRoute path="admin">
            <Admin />
          </PrivateRoute>
        }
      >
        <Route
          path=""
          element={
            <PrivateRoute path="admin">
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="calendar"
          element={
            <PrivateRoute path="admin/calendar">
              <CalendarApp />
            </PrivateRoute>
          }
        />
        <Route
          path="chat"
          element={
            <PrivateRoute path="admin/chat">
              <Chat />
            </PrivateRoute>
          }
        />
        <Route
          path="chat/:sessionParam"
          element={
            <PrivateRoute path="admin/chat">
              <Chat />
            </PrivateRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PrivateRoute path="admin/dashboard">
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="faq"
          element={
            <PrivateRoute path="admin/faq">
              <Faq />
            </PrivateRoute>
          }
        />
        <Route
          path="help"
          element={
            <PrivateRoute path="admin/help">
              <HelpCenter />
            </PrivateRoute>
          }
        />

        {/* Profile Routes */}
        <Route
          path="profile"
          element={
            <PrivateRoute path="admin/profile">
              <Profile />
            </PrivateRoute>
          }
        >
          <Route
            path=""
            element={
              <PrivateRoute path="admin/profile">
                <ProfileActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="information"
            element={
              <PrivateRoute path="admin/profile/information">
                <ProfileInformation />
              </PrivateRoute>
            }
          />
          <Route
            path="password"
            element={
              <PrivateRoute path="admin/profile/password">
                <ProfilePassword />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="redirect"
          element={
            <PrivateRoute path="admin/redirect">
              <Redirect />
            </PrivateRoute>
          }
        />

        {/* Vacancy Routes */}
        <Route
          path="vacancy"
          element={
            <PrivateRoute path="admin/vacancy">
              <Vacancy />
            </PrivateRoute>
          }
        />
        <Route
          path="vacancy/:id"
          element={
            <PrivateRoute path="admin/vacancy">
              <SelectionProvider>
                <VacancyPage />
              </SelectionProvider>
            </PrivateRoute>
          }
        />
        <Route
          path="vacancy/add"
          element={
            <PrivateRoute path="admin/vacancy/add">
              <VacancyPage />
            </PrivateRoute>
          }
        />

        {/* Emails Routes */}
        <Route
          path="emails"
          element={
            <PrivateRoute path="admin/emails">
              <Emails />
            </PrivateRoute>
          }
        />
        <Route
          path="emails/:id"
          element={
            <PrivateRoute path="admin/emails">
              <EmailsPage />
            </PrivateRoute>
          }
        />

        {/* Settings Routes */}
        <Route
          path="settings"
          element={
            <PrivateRoute path="admin/settings">
              <Settings />
            </PrivateRoute>
          }
        />

        {/* Notifications Routes */}
        <Route
          path="notifications"
          element={
            <PrivateRoute path="admin/notifications">
              <Notifications />
            </PrivateRoute>
          }
        />

        {/* Board Routes */}
        <Route
          path="board"
          element={
            <PrivateRoute path="admin/board">
              <Board />
            </PrivateRoute>
          }
        />

        {/* Res Routes */}
        <Route
          path="res"
          element={
            <PrivateRoute path="admin/res">
              <Res />
            </PrivateRoute>
          }
        />

        {/* Announce Routes */}
        <Route
          path="announce"
          element={
            <PrivateRoute path="admin/announce">
              <AnnounceTable />
            </PrivateRoute>
          }
        />
        <Route
          path="announce/:id"
          element={
            <PrivateRoute path="admin/announce">
              <Announce />
            </PrivateRoute>
          }
        />
        <Route
          path="announce/add"
          element={
            <PrivateRoute path="admin/announce/add">
              <Announce />
            </PrivateRoute>
          }
        />

        {/* Candidate Routes */}
        <Route
          path="candidate"
          element={
            <PrivateRoute path="admin/candidate">
              <CandidateTable />
            </PrivateRoute>
          }
        />
        <Route
          path="candidate/itineraries"
          element={
            <PrivateRoute path="admin/candidate">
              <Itineraries />
            </PrivateRoute>
          }
        />
        <Route
          path="candidate/:id"
          element={
            <PrivateRoute path="admin/candidate">
              <CandidatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="candidate/add"
          element={
            <PrivateRoute path="admin/candidate/add">
              <CandidatePage />
            </PrivateRoute>
          }
        />

        {/* Clients Routes */}
        <Route
          path="clients"
          element={
            <PrivateRoute path="admin/clients">
              <ClientsTable />
            </PrivateRoute>
          }
        />
        <Route
          path="clients/map"
          element={
            <PrivateRoute path="admin/clients">
              <ClientsTable defaultView="map" />
            </PrivateRoute>
          }
        />
        <Route
          path="clients/:id"
          element={
            <PrivateRoute path="admin/clients">
              <Clients />
            </PrivateRoute>
          }
        />
        <Route
          path="clients/add"
          element={
            <PrivateRoute path="admin/clients/add">
              <Clients />
            </PrivateRoute>
          }
        />

        {/* CRM Route */}
        <Route
          path="crm"
          element={
            <PrivateRoute path="admin/crm">
              <CRM />
            </PrivateRoute>
          }
        />
        {/* Reports Route */}
        <Route
          path="clients/reports"
          element={
          <PrivateRoute path="admin/clients/reports"> 
            <Reports /> 
          </PrivateRoute>}
        />

        <Route
          path="projects"
          element={<Navigate to="/under-construction" replace />}
        />
        <Route
          path="user-management"
          element={
            <PrivateRoute path="admin/user-management">
              <UserManagement />
            </PrivateRoute>
          }
        />
      </Route>

      {/* Public Routes */}
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="forgot-password-submit" element={<ForgotPasswordSubmit />} />
      <Route path="register" element={<Register />} />
      <Route path="under-construction" element={<UnderConstructions />} />
      <Route path="403" element={<Forbidden />} />
      <Route path="404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;
